import React from "react";
import styled from "styled-components";

const PrivacyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SectionTitle = styled.h2`
  font-size: 1.2em;
  margin-bottom: 10px;
  font-weight: 600;
`;

const PrivacyPolicy = () => {
  return (
    <PrivacyContainer>
      <Title>Privacy Policy</Title>

      <Section>
        <SectionTitle>1. Introduction</SectionTitle>
        <p>
          Sophie Care 26 Inc. (“Sophie Care,” “we,” “us,” or “our”) is committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, and protect your personal information when
          you use our website, mobile application, and services. By using our services, you agree to this Privacy Policy.
        </p>
      </Section>

      <Section>
        <SectionTitle>2. Information We Collect</SectionTitle>
        <p><strong>Information You Provide:</strong></p>
        <ul>
          <li><strong>Personal Information:</strong> Name, phone number, email address, and payment details when creating an account.</li>
          <li><strong>Elderly User Information:</strong> Information about your loved one (e.g., name, preferred topics of conversation).</li>
        </ul>
        <p><strong>Automatically Collected Information:</strong></p>
        <ul>
          <li><strong>Usage Data:</strong> Call logs, conversation history, and engagement metrics to enhance user experience.</li>
          <li><strong>Device Information:</strong> IP address, browser type, operating system, and other technical information for security purposes.</li>
        </ul>
        <p><strong>Cookies and Tracking Technologies:</strong> We use cookies and similar technologies to enhance functionality and security. You can disable cookies in your browser settings.</p>
      </Section>

      <Section>
        <SectionTitle>3. How We Use Your Information</SectionTitle>
        <ul>
          <li><strong>Provide and Personalize Services:</strong> Deliver AI-powered conversations tailored to the elderly user’s preferences.</li>
          <li><strong>Process Payments:</strong> Manage subscriptions and payments securely.</li>
          <li><strong>Improve Services:</strong> Analyze usage data to enhance our AI system and user experience.</li>
          <li><strong>Ensure Security:</strong> Monitor and protect against fraudulent or unauthorized activities.</li>
        </ul>
        <p>We do <strong>NOT</strong> sell, rent, or share your personal data for marketing purposes.</p>
      </Section>

      <Section>
        <SectionTitle>4. Data Sharing & Security</SectionTitle>
        <ul>
          <li><strong>Third-Party Service Providers:</strong> We only share data with trusted third-party providers (e.g., Twilio for telephony services, Stripe for payments).</li>
          <li><strong>Data Security:</strong> Data is encrypted and stored securely. Access to personal data is limited to authorized personnel.</li>
        </ul>
      </Section>

      <Section>
        <SectionTitle>5. User Rights & Choices</SectionTitle>
        <ul>
          <li><strong>Access, Correct, or Delete Personal Data:</strong> Request access to, correction of, or deletion of your personal information.</li>
          <li><strong>Opt-Out:</strong> Choose not to receive certain communications or opt-out of specific data processing activities.</li>
          <li><strong>Account Deletion:</strong> Request account deletion by contacting us at [Insert Email].</li>
        </ul>
      </Section>

      <Section>
        <SectionTitle>6. Data Retention</SectionTitle>
        <ul>
          <li><strong>Retention Period:</strong> Call transcripts and analytics are stored for [Insert Retention Period] to improve AI interactions.</li>
          <li><strong>Deletion Requests:</strong> You can request data deletion at any time.</li>
        </ul>
      </Section>

      <Section>
        <SectionTitle>7. Compliance & Legal Obligations</SectionTitle>
        <ul>
          <li><strong>General Data Protection Regulation (GDPR):</strong> For users in the European Union.</li>
          <li><strong>Health Insurance Portability and Accountability Act (HIPAA):</strong> For healthcare-related data privacy in the United States.</li>
          <li><strong>California Consumer Privacy Act (CCPA):</strong> For users in California, USA.</li>
        </ul>
      </Section>

      <Section>
        <SectionTitle>8. Contact Information</SectionTitle>
        <p>For questions, contact us at: <strong>support@sophie-care.com</strong></p>
      </Section>
      
    </PrivacyContainer>
  );
};

export default PrivacyPolicy;
